import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useReport (reportId) {
  return useQuery(['report', reportId], async () => {
    const report = await axios.get(`${getApiServer()}/reports/${reportId}`, { withCredentials: true })
    return report.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}